import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { Redirect, withRouter } from '../../utils/router-compat';
import _ from 'lodash';
import AddOfftakeEntryLeftPan from '../../components/OfftakeEntry/AddOfftakeEntryLeftPan';
import AddOfftakeEntryRightPan from '../../components/OfftakeEntry/AddOfftakeEntryRightPan';
import './OfftakeEntry.css';
import ModalService from '../../services/ModalService';
import { messages } from '../../constants/constant.message';
import OfftakeEntryService from '../../services/OfftakeEntryService';
import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';
import FleetManagerService from '../../services/FleetManagerService';

class AddOfftakeEntry extends Component {

  constructor(props) {
    super(props);
    this.state = {
      from: '',
      uploadedFile: [],
      uploadedFileData: {
        url: '',
        type: '',
        name: ''
      },
      controls: {
        invoiceNumber: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null
        },
        purchaseDate: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null
        },
        dealerName: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null
        },
        invoiceInFavorOf: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null
        },
        productDescription: {
          value: [{ description: { skuId: '', name: '' }, quantity: '', isValid: false }],
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null
        }
      },
      isValidForm: false,
      redirectToDashBoard: false,
      redirectToVerificationStatus: false,
      redirectToInvoiceVerification: false,
      isLoading: false,
      offtakeEntryQuery: '',
      offtakeByEntryData: {},
      selectedDealer: '',
      selectedInvoiceInFavorOf: ''
    };
  }

  async componentDidMount() {
    let { from, offtakeEntryQuery } = this.state;
    const query = new URLSearchParams(this.props.location.search);

    offtakeEntryQuery = {
      uuid: window.atob(query.get('uuid') || ''),
      fleetId: window.atob(query.get('fleetId') || ''),
    };
    if (offtakeEntryQuery.uuid) {
      this.getOfftakeEntryById(offtakeEntryQuery.uuid);
      from = 'verification'
    }
    
    await this.setState({ offtakeEntryQuery, from });

    if (!offtakeEntryQuery.uuid) {
      this.openFileBox();
    }
  }


  getOfftakeEntryById = async (id) => {
    const { controls } = this.state;
    let { offtakeByEntryData, uploadedFile, uploadedFileData, selectedDealer, selectedInvoiceInFavorOf } = this.state;
    const { invoiceNumber, purchaseDate, dealerName, invoiceInFavorOf, productDescription } = controls;
    try {
      const obj = {
        id
      };
      const { data } = await FleetManagerService.getOfftakeEntryById(obj);
      if (data.data && data.data[0]) {
        offtakeByEntryData = data.data[0];

        /* uploadedFileData = {
          name: offtakeByEntryData.invoice,
          url: offtakeByEntryData.invoice_url,
          type: offtakeByEntryData.type
        }; */

        uploadedFile = offtakeByEntryData.invoice_url;

        invoiceNumber.value = offtakeByEntryData.invoice_number;
        purchaseDate.value = new Date(offtakeByEntryData.purchase_date);
        dealerName.value = offtakeByEntryData.dealer_name;

        invoiceInFavorOf.value = {
          subsidiary_id: offtakeByEntryData.subsidiary_id,
          subsidiary_name: offtakeByEntryData.subsidiary_name
        };
        productDescription.value = offtakeByEntryData.product;

        selectedDealer = dealerName.value;
        selectedInvoiceInFavorOf = invoiceInFavorOf.value;
      }
      this.setState({ offtakeByEntryData, selectedDealer, selectedInvoiceInFavorOf, uploadedFile, uploadedFileData, controls },()=>{
      });
    } catch (error) {
      console.log(error);
    }
  }

  initState = () => {
    window.location.reload(false);
  }

  openFileBox = () => {
    const fileInput = document.getElementById('addOfftakeEntryFileInput');
    if (fileInput) {
        fileInput.click();
    }
  }

  uploadClick = event => {
    let { isLoading } = this.state;
    isLoading = true;
    this.setState({ isLoading });
    if (event.target.files[0]) {
      const file = new FormData();
      file.append('file', event.target.files[0]);

      this.uploadFile(file);
    }
  }

  uploadFile = async (file) => {
    let { uploadedFile, uploadedFileData } = this.state;
    try {
      const { data } = await OfftakeEntryService.uploadInvoice(file);
      if (data && data.data) {

        uploadedFileData = data.data;

        uploadedFile.push(uploadedFileData);

        this.setState({uploadedFile, uploadedFileData });
      }
      let { isLoading } = this.state;
      isLoading = false;
      this.setState({ isLoading });
    } catch (error) {
      console.log(error);
      let { isLoading } = this.state;
      isLoading = false;
      this.setState({ isLoading });
    }
  }

  cancelClick = () => {
    const { offtakeEntryQuery } = this.state;
    let { redirectToDashBoard, redirectToInvoiceVerification } = this.state;
    ModalService.openAlertWithPopup(messages.OFFTAKE_REGISTRATION.ONCANCELCLICKTITLE,
      messages.OFFTAKE_REGISTRATION.ONCANCELCLICKMESSAGE, 'warning', ['No', 'Yes'], (isConfirm) => {
        if (isConfirm) {
          if (offtakeEntryQuery.uuid) {
            redirectToInvoiceVerification = true;
            this.setState({ redirectToInvoiceVerification });
          } else {
            redirectToDashBoard = true;
            this.setState({ redirectToDashBoard });
          }
        }
      });
  }

  saveClick = async () => {
    let { isLoading } = this.state;
    const saveObj = this.parseObj();
    try {
      isLoading = true;
      this.setState({ isLoading });

      const { data } = await OfftakeEntryService.addOfftakeEntry(saveObj);
      isLoading = false;
      this.setState({ isLoading });
      if (data && data.success) {
        ModalService.openAlertWithPopup('Congratulations!', messages.OFFTAKE_REGISTRATION.SUCCESSADDOFFTAKENTERY, 'success', ['Upload More', 'View Verification Status'], (isConfirm) => {
          if (isConfirm) {
            this.setState({ redirectToVerificationStatus: true });
          } else {
            this.initState();
          }
        });
      }

    } catch (e) {
      isLoading = false;
      this.setState({ isLoading });
      if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
        ModalService.openAlert('', e.response.data.error[0].message, 'error');
      }
      // ModalService.openAlert('Sorry!', messages.OFFTAKE_REGISTRATION.ALREADYEXISTINVOICE, 'error');
    }
  }

  updateClick = async () => {
    const { offtakeEntryQuery, offtakeByEntryData } = this.state;
    let { isLoading, redirectToDashBoard, redirectToInvoiceVerification } = this.state;
    const updateObj = this.parseObj();

    updateObj.uuid = offtakeEntryQuery.uuid;
    updateObj.fleet_id = offtakeByEntryData.fleet_id;

    try {
      isLoading = true;
      this.setState({ isLoading });
      const { data } = await OfftakeEntryService.updateOfftakeEntry(updateObj);
      isLoading = false;
      this.setState({ isLoading });
      if (data && data.success) {
        ModalService.openAlert('Congratulations!', messages.OFFTAKE_REGISTRATION.SUCCESSUPDATEOFFTAKENTERY, 'success');
        if (offtakeEntryQuery.uuid) {
          redirectToInvoiceVerification = true;
          this.setState({ redirectToInvoiceVerification });
        } else {
          redirectToDashBoard = true;
          this.setState({ redirectToDashBoard });
        }
      }

    } catch (error) {
      console.log(error);
      isLoading = false;
      this.setState({ isLoading });
      ModalService.openAlert('Sorry!', messages.OFFTAKE_REGISTRATION.ERRORMESSAGE, 'error');
    }
  }

  parseObj() {
    const { controls, uploadedFile
      // , uploadedFileData
     } = this.state;
    const { invoiceNumber, purchaseDate, dealerName, invoiceInFavorOf, productDescription } = controls;

    let invoice_urls = uploadedFile.map(function(item) {
      return item['url'];
    });

    const obj = {
      'invoice_number': invoiceNumber.value,
      'dealer_name': dealerName.value,
      'subsidiary_id': invoiceInFavorOf.value && invoiceInFavorOf.value.subsidiary_id,
      'purchase_date': purchaseDate.value, // may need to change zone
      // 'invoice_url': uploadedFileData.url,
      'invoice_url': invoice_urls,
      'product': _.compact(_.map(_.cloneDeep(productDescription.value), (item) => {
        if (item.quantity && item.description && item.description.sku_id) {
          return { description: item.description, quantity: item.quantity };
        }
      }))
    };

    return obj;
  }

  deleteInvoice = (data) => {
    const {uploadedFile} = this.state;

    let index = uploadedFile.findIndex(x => x.url ===data.url);

    uploadedFile.splice(index, 1);

    this.setState({uploadedFile});
  }

  render() {
    const { isLoading, uploadedFile, uploadedFileData, controls, isValidForm, redirectToDashBoard, redirectToVerificationStatus, redirectToInvoiceVerification, offtakeEntryQuery,
      selectedDealer, selectedInvoiceInFavorOf, from } = this.state;
    return (
      <div>
        {isLoading && <CustomSpinner />}
        <input id="addOfftakeEntryFileInput" onChange={this.uploadClick} type="file" accept="image/*, application/pdf" style={{ display: 'none' }} />
        {redirectToDashBoard && <Redirect to="/" />}
        {redirectToVerificationStatus && <Redirect to="/offtakeEntriesVerificationStatus" />}
        {redirectToInvoiceVerification && <Redirect to="/invoiceVerification" />}
        <Row>
          <Col>
            <span className="offtake-title">Add Offtake Entry</span>
            &nbsp;&nbsp;
            <span onClick={this.cancelClick} style={{ color: ' #0056b3', cursor: 'pointer', fontSize: '14px' }}>Cancel</span>
          </Col>
        </Row>

        <Row className="offtake-wrapper">
          <Col>
            <Card>
              <CardBody>
                <AddOfftakeEntryLeftPan uploadedFile={uploadedFile} uploadedFileData={uploadedFileData} openFileBox={this.openFileBox} deleteInvoice={this.deleteInvoice} from={from}/>
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card>
              <CardBody>
                <AddOfftakeEntryRightPan uploadedFile={uploadedFile} controls={controls} uploadedFileData={uploadedFileData} isValidForm={isValidForm} saveClick={this.saveClick} updateClick={this.updateClick} offtakeEntryQuery={offtakeEntryQuery} selectedDealer={selectedDealer} selectedInvoiceInFavorOf={selectedInvoiceInFavorOf} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(AddOfftakeEntry);